<template>
	<v-toolbar
		app
		flat
		fixed
		extended
		color="primary navbartext--text"
		height="60"
		tabs
	>
		<v-toolbar-side-icon title="Menu" color="navbartext--text" @click="menuAction"></v-toolbar-side-icon>	
		<v-spacer></v-spacer>
		<comp-action-toolbar v-if="$route.meta.actionToolbar" />
		<v-btn
			title="Más opciones"
			color="navbartext--text mx-0"
			icon
			@click="sidebarExtraAction"
			v-if="extraSidebar.compSidebar"
		>
			<v-icon>
				more_horiz
			</v-icon>
		</v-btn>
		<v-menu offset-y>
			<v-btn
				title="Usuario"
				slot="activator"
				color="navbartext--text mx-0"
				icon
			>
				<v-icon>person</v-icon>
			</v-btn>
			<v-list class="">
				<v-list-tile
					@click="logout"
				>
					<v-list-tile-title>Salir</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>
		<template v-slot:extension>
			<v-container py-0 mx-auto>
				<comp-toolbar-tabs v-if="$route.meta.tabs" />
				<comp-toolbar-list v-if="$route.meta.list" />
			</v-container>
		</template>
	</v-toolbar>
</template>

<script>
import { typeLogins } from '@/config'
import { mapState } from 'vuex'
import compActionToolbar from './Item'
import compToolbarTabs from '../Toolbars/ToolbarTabs'
import compToolbarList from '../Toolbars/ToolbarList'

export default {
	components: {
		compActionToolbar,
		compToolbarTabs,
		compToolbarList
	},
	methods: {
		logout() {
			if (typeLogins.type == 'simple') {
				this.$store.commit('login/logoutUser')
			} else {
				this.$store.dispatch('login/logout')
			}
			this.$router.go()
		},
		menuAction() {
			this.$store.commit('toggleMenuDrawer')
		},
		sidebarExtraAction() {
			this.$store.commit('toggleSibebarExtraDrawer')
		}
	},
	computed: {
		...mapState(['extraSidebar'])
	}
}
</script>

<style lang="scss">
.v-toolbar__extension {
	padding: 0px !important;
}
</style>
